import React from "react";
import { badgeType } from "../constants";
import { Badge } from "react-bootstrap";

/*
props = {
  children: <string>
  type: <bootstrap badge class type. refer - https://getbootstrap.com/docs/4.0/components/badge/#contextual-variations>
}
*/

const ChrBadge = (props) => {
  const type = props.type || badgeType.success;
  return (
    <Badge className={ `badge badge-${type} ${props.className}` }>
      { props.children }
    </Badge>
  );
}

export default ChrBadge;
